import Icon from '../components/Icon.vue'

Icon.register({
  asterisk: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M478.2 334.1c11.8 6.5 16 21.4 9.2 33l-19.5 33.7c-6.7 11.7-21.7 15.5-33.2 8.5l-138.7-84.1 3.5 162.2c0.3 13.5-10.5 24.5-24 24.5h-39c-13.5 0-24.3-11.1-24-24.5l3.5-162.2-138.7 84.1c-11.5 7-26.5 3.1-33.2-8.5l-19.5-33.7c-6.7-11.7-2.6-26.6 9.2-33l142.2-78.1-142.2-78.1c-11.8-6.5-16-21.4-9.2-33l19.5-33.7c6.7-11.7 21.7-15.5 33.2-8.5l138.7 84.1-3.5-162.2c-0.3-13.5 10.5-24.5 24-24.5h39c13.5 0 24.3 11.1 24 24.5l-3.5 162.2 138.7-84.1c11.5-7 26.5-3.1 33.2 8.5l19.5 33.7c6.7 11.7 2.6 26.6-9.2 33l-142.2 78.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/asterisk.js
// module id = 628
// module chunks = 0